import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  OauthAEMConfig,
  SkymilesNumberPayload,
  SubmitSkymilesNumber
} from '../../../models';
import { UtilService } from '../../util-service/util-service';
@Injectable({
  providedIn: 'root'
})
export class PostSkymilesNumberService {
  submitSkymilesNumberHeader: HttpHeadersPayload = {
    'Content-Type':
      'application/vnd.pingidentity.checkAccountRecoveryUsername+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitSkymilesNumber = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    skymilesNumber: string
  ): Observable<SubmitSkymilesNumber> => {
    const url = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitSkymilesNumberUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: url
      }
    ];

    const payload: SkymilesNumberPayload = {
      username: skymilesNumber
    };

    return new ApiBuilder<SkymilesNumberPayload, SubmitSkymilesNumber>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitSkymilesNumberUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitSkymilesNumberHeader)
      .errorHandler(this._errorHandler)
      .library('POST_SKYMILES_NUMBER_SERVICE')
      .withCredentials(true)
      .create();
  };
}
